/**
 * Middlware for configuring API request-based actions with base URL for APIV
 * and adding the authenication header
 */
import { RSAA } from 'redux-api-middleware';

import { selectors } from '../../dux/user';

/**
 * For CALL_API actions, prefixes the endpoint URL with APIV if base URL is not
 * specified and adds an authorization header for APIV calls
 *
 * @param {object} action - Action to modify
 * @returns {object} - The action augmented with any API-related properties if
 *  it is a CALL_API action or the original action otherwise.
 */
export default (store) => (next) => (action) => {
  const callApi = action[RSAA];
  const { impersonatedOrganizationId } = selectors.getIdentityState(store.getState());

  if (callApi) {
    // Prefix URL with APIV base URL if not specified
    if (!callApi.endpoint.match(/http/i)) {
      callApi.endpoint = `${process.env.REACT_APP_APIV5_BASE_URL}${callApi.endpoint}`;
    }

    // Append org ID if an org is being impersonated
    if (impersonatedOrganizationId) {
      callApi.endpoint = `${callApi.endpoint}?organization=${impersonatedOrganizationId}`;
    }

    // If call for APIV, add auth token header (if needed) and content type
    if (callApi.endpoint.includes(process.env.REACT_APP_APIV5_BASE_URL)) {
      if (callApi.endpoint.match(/\/userinvite\/validate\/|\/userinvite\/accept\//i)) {
        callApi.headers = {
          ...callApi.headers,
          'Content-Type': 'application/json',
        };
      } else {
        callApi.headers = {
          ...callApi.headers,
          Authorization: `Bearer ${selectors.getCredentialsState(store.getState()).accessToken}`,
          'Content-Type': 'application/json',
        };
      }
    }
  }
  return next(action);
};
